import { apiSlice } from 'api/apiSlice'
import { Store } from 'shared/types/Store'

const storesApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getStores: build.query<{flightclubStores: Store[]}, void>({
      query: () => ({
        app: 'sneakers',
        cache: false,
        method: 'GET',
        url: '/web-api/v1/flightclub_stores',
      }),
    }),
  }),
})

export const {
  useGetStoresQuery,
} = storesApi
